<template>
  <div style="clear:both;">
    <v-dialog v-model="addBulkUsersDialog" persistent max-width="700">
      <v-card max-width="800">
        <v-toolbar elevation="1" density="compact" :title="$t('Add_Bulk_Users')">
        <v-spacer></v-spacer>
        <v-tooltip :text="$t('Help')" location="bottom">
          <template v-slot:activator="{ props }">
             <v-btn icon @click="showHelp = true" v-bind="props">
                <v-icon v-on="on">mdi-help-circle-outline</v-icon>
              </v-btn>
          </template>
        </v-tooltip>
      </v-toolbar>
        <v-container fluid>
          <v-form @submit.prevent v-model="valid">
            <v-textarea
              v-model="bulkAddUsers"
              label="Enter Users AP email addresses here, each on their own line"
              solo
              spellcheck="false"
              :rules="bulkUserAddRules"
            >
            </v-textarea>
            <span>User Count: {{ lineCount }} / {{ maxBulkAddUsersCount }}</span>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="submitBulkUsers()" class="mx-2" v-if="this.lineCount <= this.maxBulkAddUsersCount">
                {{ $t('Insert_Users') }}
                <v-icon right>mdi-check</v-icon>
              </v-btn>
              <v-btn color="error" @click="close()" class="mx-2"
                >{{ $t('Cancel') }}
                <v-icon right>mdi-cancel</v-icon>
              </v-btn>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>

    <template>
      <v-dialog v-model="showHelp" persistent max-width="400">
        <v-card>
          <v-toolbar elevation="1" color="warning" density="compact">
            <v-spacer></v-spacer><v-icon class="me-5" color="black">mdi-bell-alert-outline</v-icon>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-card-text> {{ $t('Add_Bulk_Users_Help') }} </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="showHelp = false">{{ $t('OK') }}</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addBulkUsersDialog: true,
      bulkAddUsers: '',
      showHelp: false,
      maxBulkAddUsersCount: 25,
      bulkUserAddRules: [
        v => !!v || 'Required',
        v => (v && this.lineCount <= this.maxBulkAddUsersCount) || `Limit is ${this.maxBulkAddUsersCount}`
      ],
      valid: true
    }
  },
  props: {
    color: {
      type: String,
      default: null
    },
    currentUsers: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submitBulkUsers() {
      this.$emit('bulkUsers', [...new Set(this.bulkAddUsers.split(/\r?\n/))])

      this.close()
    }
  },
  computed: {
    bgColor() {
      return this.color ? this.color : null
    },
    lineCount: function() {
      // Return number of lines using regex if not empty
      return this.bulkAddUsers.length ? this.bulkAddUsers.split(/\r\n|\r|\n/).length : 0
    }
  }
}
</script>

<style scoped></style>
